import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SearchItemSkeleton = ({ viewmode }) => {
	return (
		<div
			className={`column is-${viewmode === "List" ? 12 : 4}`}
			style={{ cursor: "pointer" }}
		>
			<div className="card p-5">
				<div className={`card-body ${viewmode === "List" ? "columns" : ""}`}>
					<div
						className={`user-info ${viewmode === "List" ? "columns column is-4 mb-0" : ""}`}
						style={{ textAlign: "center" }}
					>
						<div className={viewmode === "List"?"column is-5":""}>
							<Skeleton circle style={{ width: 100, height: 100 }} />
						</div>
						<div className={viewmode === "List"?"column is-7 mt-2":""}>
							<Skeleton
								style={{ height: 25, marginTop: 10, marginBottom: 10 }}
							/>
                            {viewmode === "List"? <Skeleton /> : null}
						</div>
					</div>
					<div
						className={`${viewmode === "List" ? "column is-4" : ""}`}
						style={{ marginTop: 15 }}
					>
						<Skeleton />
						<Skeleton />
						<Skeleton />
					</div>
					<div className={`${viewmode === "List" ? "column is-4" : ""}`}>
						<style>
							{`
                                .button.is-small {
                                    font-size: 10px;
                                    font-weight: 500;
                                }
                            `}
						</style>
						<div className="filters py-4">
							<div className="buttons">
								{[1, 2, 3, 4].map(() => {
									return (
										<Skeleton
											style={{
												width: 50,
												height: 50,
												margin: 5,
												borderRadius: 50,
											}}
										/>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SearchItemSkeleton;
